<template>
  <div :class="disabled ? 'fdc-eqp-tree disabled' : 'fdc-eqp-tree'">
    <template v-if="useSearchField">
      <b-input
        v-model="treeSearch"
        class="tree-search"
      />
    </template>
    <tree
      ref="tree"
      :data="treeNodes"
      :search="treeSearch"
      :use-checkbox="useCheckbox"
      :use-filter="true"
      :option="treeOption"
      :draggable="false"
      @node-change-check="changeCheck"
    />
    <div
      v-if="this.treeNodes.length <= 0"
      class="loading-overlay is-active eqp-tree-no-data"
    >
      {{ $t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_FOUND') }}
    </div>
  </div>
</template>

<script>
import API from '@/views/Fdc/Apis/'
import Tree from './Tree'

export default {
  name: 'EqpTree',
  components: {
    'tree': Tree
  },
  props: {
    /**
     * Tree Type을 정의힙니다.
     * @param {String} treeType
     * 1. 'eqpModel'  : fab > line > area > eqpModel
     * 2. 'eqp'       : fab > line > area > eqpModel > eqpId
     * 3. 'module'    : fab > line > area > eqpModel > eqpId > moduleId
     */
    treeType: {
      type: String,
      default: 'module'
    },
    /**
     * Checkbox 사용 여부를 정의힙니다.
     * @param {Boolean} useCheckbox true or false
     */
    useCheckbox: {
      type: Boolean,
      default: false
    },
    /**
     * Search Field 사용 여부를 정의힙니다.
     * @param {Boolean} useSearchField true or false
     */
    useSearchField: {
      type: Boolean,
      default: true
    },
    /**
     * Tree Collapse 및 Active 세팅을 정의합니다.
     * @param {Object} nodeObj
     */
    nodeObj: {
      type: Object,
      default: null
    },
    /**
     * Array에 대해 Tree Collapse 및 Active 세팅을 정의합니다.
     * @param {Array} nodeArr
     */
    nodeArr: {
      type: Array,
      default: null
    },
    /**
     * nodeObj 설정 시 callback 함수를 정의합니다.
     * @param {Function} nodeObjCallBack
     */
    nodeObjCallBack: {
      type: Function,
      default: () => {}
    },
    /**
     * 기간으로 tree를 검색할 때 true로 설정합니다.
     * @param {Boolean} usePeriod true or false
     */
    usePeriod: {
      type: Boolean,
      default: false
    },
    /**
     * Tree component를 disabled 설정합니다.
     * @param {Boolean} disabled true or false
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (!this.usePeriod) {
      let storeTreeType = this.$store.getters['searchCondition:eqpTreeType']
      if (storeTreeType !== null) {
        this.storeEqpTreeType = storeTreeType
      }

      let storeTreeObj = this.$store.getters['searchCondition:eqpTreeObj']
      let storeTreeLevel = this.$store.getters['searchCondition:eqpTreeLevel']
      if (storeTreeObj !== null && storeTreeObj !== undefined) {
        this.storeEqpTreeObj = storeTreeObj
        this.storeEqpTreeLevel = storeTreeLevel
      }
      console.log('EQP tree store', this.storeEqpTreeType, this.storeEqpTreeObj, this.storeEqpTreeLevel)

      this.getTree()
    }
  },
  watch: {
    treeSearch: function (newVal) {
      return newVal
    },
    treeType: function () {
      if (!this.usePeriod) {
        this.getTree()
      }
    }
  },
  methods: {
    async getTree () {
      let response = await API.Common.getEqpInfoTree(this.treeType)
      if (response) {
        this.treeNodes = this.parseNodes(response)
        // tree collapse set
        if (this.nodeObj !== null || JSON.stringify(this.storeEqpTreeObj) !== JSON.stringify({})) {
          this.treeNodes.forEach((tree) => {
            this.settingCollapse(tree)
          })
        }

        // tree collapse set
        if (this.nodeArr !== null) {
          setTimeout(() => {
            this.treeNodes.forEach((tree) => {
              this.settingMultiDataCollapse(tree)
            })
          }, 100)
        }
      }
    },
    async getEventTree (fromDate, toDate) {
      let payload = {
        treeType: this.treeType,
        fromDate: fromDate,
        toDate: toDate
      }

      let response = await API.Common.getEqpHistoryTree(payload)
      if (response) {
        this.treeNodes = this.parseNodes(response)
        // tree collapse set
        if (this.nodeObj !== null || JSON.stringify(this.storeEqpTreeObj) !== JSON.stringify({})) {
          this.treeNodes.forEach((tree) => {
            this.settingCollapse(tree)
          })
        }

        // tree collapse set
        if (this.nodeArr !== null) {
          setTimeout(() => {
            this.treeNodes.forEach((tree) => {
              this.settingMultiDataCollapse(tree)
            })
          }, 100)
        }
      }
    },
    settingCollapse (nodes) {
      if (Object.prototype.hasOwnProperty.call(nodes, 'children')) {
        nodes.children.forEach((node) => {
          if (this.parseObj !== null && this.parseObj !== undefined) {
            if (this.parseObj.area === node.detail.area) {
              node.isCollapsed = false
            }

            if (node.detail.eqpModel !== '' && node.detail.eqpId === '') {
              if (this.parseObj.eqpModel !== node.detail.eqpModel) {
                node.isCollapsed = true
              }
            }

            if (node.detail.eqpModel !== '' && node.detail.eqpId !== '') {
              if (this.parseObj.eqpId !== node.detail.eqpId) {
                node.isCollapsed = true
              }
            }
          }
          return this.settingCollapse(node)
        })
      }
    },
    settingMultiDataCollapse (nodes) {
      if (Object.prototype.hasOwnProperty.call(nodes, 'children')) {
        nodes.children.forEach((node) => {
          for (let i = 0; i < this.parseArr.length; i++) {
            if (this.parseArr[i].area === node.detail.area && node.detail.eqpModel === '') {
              node.isCollapsed = false
            }
            if (node.detail.eqpModel !== '' && node.detail.eqpModel === this.parseArr[i].eqpModel && node.detail.area && node.detail.eqpId === '') {
              node.isCollapsed = false
            }
            if (node.detail.eqpId !== '' && node.detail.eqpId === this.parseArr[i].eqpId) {
              node.isCollapsed = false
              if (node.detail.moduleId === this.parseArr[i].moduleId) {
                // node.isActive = true
                node.isChecked = true
                // node.click('', node)
                // console.log('settingMultiDataCollapse', [node])
                this.$refs.tree.setCheckToParentNodes([node])
                // this.$refs.tree.nodeChangeCheck()
                // this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
              }
            }
          }
          return this.settingMultiDataCollapse(node)
        })
      }
    },
    parseNodes (nodes) {
      let treeNodes = nodes
      // let jsonNodeObj = JSON.stringify(this.nodeObj)
      let parseNode = (node, parent) => {
        if (!node.detail.area) {
          node.isCollapsed = false
        } else {
          node.isCollapsed = true
        }

        // tree node active 및 callback 필요 시 사용
        if (this.nodeObj !== null && this.nodeObj.constructor === Object) {
        // if (jsonNodeObj !== JSON.stringify({})) {
          // console.log(this.nodeObj);
          if (this.treeType === 'module' &&
            this.nodeObj.moduleId === node.detail.moduleId &&
            this.nodeObj.eqpId === node.detail.eqpId &&
            this.nodeObj.fab === node.detail.fab) {
            this.setTreeData(node)
            this.nodeObjCallBack()
          } else if (this.treeType === 'eqp' &&
            this.nodeObj.eqpId === node.detail.eqpId &&
            this.nodeObj.fab === node.detail.fab) {
            this.setTreeData(node)
            this.nodeObjCallBack()
          } else if (this.treeType === 'eqpModel') {
            if (JSON.stringify(this.nodeObj) === JSON.stringify(node.detail)) {
              this.parseObj = { ...node.detail }
              node.isActive = true
            }
          }
        } else if (this.nodeArr !== null && this.nodeArr.constructor === Array) {
          // ltempArr = []
          this.nodeArr.forEach(nodeObj => {
            if (this.treeType === 'module' && nodeObj.detail.moduleId === node.detail.moduleId) {
              this.tempArr.push(node.detail)
              this.setMultiSelectTreeData(this.tempArr)
            }
          })
        } else if (JSON.stringify(this.storeEqpTreeObj) !== JSON.stringify({})) {
          if (this.treeType === this.storeEqpTreeType) {
            if (JSON.stringify(this.storeEqpTreeObj) === JSON.stringify(node.detail)) {
              this.setTreeData(node)
            }
          } else {
            if (this.storeEqpTreeLevel === 5 &&
              this.storeEqpTreeObj.moduleId === node.detail.moduleId) {
              this.setTreeData(node)
            } else if (this.treeType === 'eqp') {
              if (node.detail.moduleId === '' &&
                node.detail.eqpId !== '' &&
                this.storeEqpTreeObj.eqpId === node.detail.eqpId &&
                this.storeEqpTreeObj.eqpModel === node.detail.eqpModel &&
                this.storeEqpTreeObj.area === node.detail.area &&
                this.storeEqpTreeObj.line === node.detail.line &&
                this.storeEqpTreeObj.fab === node.detail.fab
              ) {
                this.setTreeData(node)
              }
            } else if (this.treeType === 'eqpModel') {
              if (node.detail.moduleId === '' &&
                node.detail.eqpId === '' &&
                node.detail.eqpModel !== '' &&
                this.storeEqpTreeObj.eqpModel === node.detail.eqpModel &&
                this.storeEqpTreeObj.area === node.detail.area &&
                this.storeEqpTreeObj.line === node.detail.line &&
                this.storeEqpTreeObj.fab === node.detail.fab
              ) {
                this.setTreeData(node)
              }
            }

            if (this.storeEqpTreeLevel === 4 &&
              node.detail.moduleId === '' &&
              this.storeEqpTreeObj.eqpId === node.detail.eqpId
            ) {
              this.setTreeData(node)
            } else if (this.treeType === 'eqpModel') {
              if (node.detail.moduleId === '' &&
                node.detail.eqpId === '' &&
                node.detail.eqpModel !== '' &&
                this.storeEqpTreeObj.eqpModel === node.detail.eqpModel &&
                this.storeEqpTreeObj.area === node.detail.area &&
                this.storeEqpTreeObj.line === node.detail.line &&
                this.storeEqpTreeObj.fab === node.detail.fab
              ) {
                this.setTreeData(node)
              }
            }

            if (this.storeEqpTreeLevel === 3 &&
              node.detail.moduleId === '' &&
              node.detail.eqpId === '' &&
              this.storeEqpTreeObj.eqpModel === node.detail.eqpModel &&
              this.storeEqpTreeObj.area === node.detail.area &&
              this.storeEqpTreeObj.line === node.detail.line &&
              this.storeEqpTreeObj.fab === node.detail.fab) {
              this.setTreeData(node)
            }

            if (this.storeEqpTreeLevel === 2 &&
              node.detail.moduleId === '' &&
              node.detail.eqpId === '' &&
              node.detail.eqpModel === '' &&
              this.storeEqpTreeObj.area === node.detail.area &&
              this.storeEqpTreeObj.line === node.detail.line &&
              this.storeEqpTreeObj.fab === node.detail.fab) {
              this.setTreeData(node)
            }

            if (this.storeEqpTreeLevel === 1 &&
              node.detail.moduleId === '' &&
              node.detail.eqpId === '' &&
              node.detail.eqpModel === '' &&
              node.detail.area === '' &&
              this.storeEqpTreeObj.line === node.detail.line &&
              this.storeEqpTreeObj.fab === node.detail.fab) {
              this.setTreeData(node)
            }

            if (this.storeEqpTreeLevel === 0 &&
              node.detail.moduleId === '' &&
              node.detail.eqpId === '' &&
              node.detail.eqpModel === '' &&
              node.detail.area === '' &&
              node.detail.line === '' &&
              this.storeEqpTreeObj.fab === node.detail.fab) {
              this.setTreeData(node)
            }

            // if (this.storeEqpTreeObj.detail.moduleId !== '' && this.storeEqpTreeObj.detail.moduleId === node.detail.moduleId) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // } else if (this.storeEqpTreeObj.detail.eqpId !== '' && this.storeEqpTreeObj.detail.eqpId === node.detail.eqpId) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // } else if (this.storeEqpTreeObj.detail.eqpModel !== '' && this.storeEqpTreeObj.detail.eqpModel === node.detail.eqpModel) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // } else if (this.storeEqpTreeObj.detail.area !== '' && this.storeEqpTreeObj.detail.area === node.detail.area) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // } else if (this.storeEqpTreeObj.detail.line !== '' && this.storeEqpTreeObj.detail.line === node.detail.line) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // } else if (this.storeEqpTreeObj.detail.fab !== '' && this.storeEqpTreeObj.detail.fab === node.detail.fab) {
            //   this.parseObj = { ...node.detail }
            //   this.selectedTreeNode = node
            //   this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
            //   node.isActive = true
            // }
          }
        }

        // let nodeParent = parent
        node.parents = [...parent.parents, node.title]
        node.click = (e, node) => {
          if (node.isCollapsed) {
            node.isCollapsed = false
          }
          if (this.useCheckbox) {
            if (node.isChecked) {
              node.isChecked = false
            } else {
              node.isChecked = true
            }
            // click 시 children 도 check
            let checkboxChecked = (node) => {
              if (node.children) {
                node.children.forEach(data => {
                  data.isChecked = !data.isChecked
                  checkboxChecked(data)
                })
              }
            }
            checkboxChecked(node)
            // parent node controll
            this.$refs.tree.setCheckToParentNodes([node])
            this.$refs.tree.nodeChangeCheck()

            // if (nodeParent.isChecked) {
            //   node.isChecked = true
            // }
            let checkedTreeNodes = []
            let setCheckedTreeNodes = (nodes) => {
              nodes.forEach(node => {
                if (node.isChecked) {
                  checkedTreeNodes.push(node)
                }
                if (node.children) {
                  setCheckedTreeNodes(node.children)
                }
              })
            }
            setCheckedTreeNodes(treeNodes)
            // this.$emit('fdc-eqp-tree-checked', checkedTreeNodes)
          }
          this.selectedTreeNode = node
          this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
          // this.$store.dispatch('eqpTreeSelected', this.selectedTreeNode)
        }
        if (node.children) {
          node.children.forEach(child => {
            if (this.parentArea === child.detail.area) {
              child.isCollapsed = false
            }
            child = parseNode(child, node)
          })
          return node
        }
      }
      nodes.forEach(node => {
        node = parseNode(node, { parents: [] })
      })
      return nodes
    },
    setTreeData (node) {
      // console.log(node)
      this.parseObj = { ...node.detail }
      this.selectedTreeNode = node
      this.$emit('fdc-eqp-tree-selected', this.selectedTreeNode)
      node.isActive = true
    },
    setMultiSelectTreeData (nodes) {
      this.parseArr = [...nodes]
      // console.log(this.parseObj)
    },
    changeCheck (nodes) {
      console.log(nodes)
      this.checkedTreeNode = []
      this.setCheckNodeList(nodes)
    },
    setCheckNodeList (nodes) {
      // let checkArrNode = []
      nodes.forEach(node => {
        if (node.children.length > 0) {
          this.setCheckNodeList(node.children)
        } else {
          if (node['isChecked']) {
            this.checkedTreeNode.push(node)
          }
        }
      })
      // this.checkedTreeNode = checkArrNode
      this.$emit('fdc-eqp-tree-checked', this.checkedTreeNode)
    }
  },
  data: function () {
    return {
      tempArr: [],
      treeNodes: [],
      treeSearch: '',
      selectedTreeNode: [],
      checkedTreeNode: [],
      treeOption: {
        collapseAll: false
      },
      parentArea: null,
      parseObj: null,
      parseArr: [],
      storeEqpTreeObj: {},
      storeEqpTreeType: null,
      storeEqpTreeLevel: null
    }
  }
}
</script>

<style lang="scss">
#app{
  .fdc-eqp-tree {
    padding: 10px;
    height: 100%;
    position: relative;
    .tree-search {
      margin-bottom: $gap;
    }
    // tree 뒷 배경
    // .-\31 8532 {
    //   width: 198px;
    //   height: 18px;
    //   background-color: rgba(71, 186, 193, 0.2);
    // }
    .tree {
      .tree-node {
        .node-header {
          .header-body {
            &:hover {
              background-color: $skyblue-light; // $mint-light;
            }
            .node-title {
              &.-clickable {
                cursor: pointer;
                &:hover {
                  // color: #000;
                  font-weight: 600;
                }
                .node-checkbox {
                  vertical-align: -3px;
                  &:checked {
                    background: #000;
                  }
                  &:checked + .title-string {
                    // color: #000;
                    font-weight: 600;
                  }
                }
                // .node-checkbox
              }
            }
          }
        }
        &.-active {
          > .node-header .node-title {
            // color: #000;
            font-weight: 600;
          }
          > .node-header .header-body {
            background-color: $skyblue-light; // $mint-light;
          }
        }
      }
    }
  }
  .fdc-eqp-tree.disabled {
    pointer-events: none;
    opacity: 0.4;
  }
}
</style>
